module.exports = __webpack_public_path__ + "ky.svg?bae94ee77ef2bcfedc9990a4b4eaa4b7";